import { render, staticRenderFns } from "./localeUpdater.vue?vue&type=template&id=80a0d888"
import script from "./localeUpdater.ts?vue&type=script&lang=ts&external"
export * from "./localeUpdater.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports